import React, { useEffect } from "react";
import { Container, Card, Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Home from './../../assets/home-service.svg';
import Evaluate from './../../assets/evaluate.svg';
import FullService from './../../assets/full-service.svg';
import UsingService from './../../assets/using-service.svg';
import styles from './style.module.css';

function TimeLineChart(props) {

    return (
        <>
            <div style={{ backgroundColor: "#eeeeee" }} >
                <div style={{ fontSize: "25px", fontWeight: "bold", fontFamily: "Raleway" }} className="pt-3 text-center mb-2">How it Works</div>
                <Row>
                    <div className="offset-lg-1 col-lg-10">
                        <div className="container">
                            <Row className="col-lg-12">
                                <div className={"col-lg-3 col-md-12 col-sm-12 text-center p-3"}>
                                    {/* <FontAwesomeIcon icon="registered" size="2x" /> */}
                                    <Row style={{ position: "relative" }}>
                                        <Col className="ps-3 col-2 col-sm-2 col-md-2 col-lg-12 text-center">
                                            <hr className={styles.dottedLine} />
                                            <img src={Home} alt="React Logo" className={styles.image} />
                                        </Col>
                                        <Col className="col-10 col-sm-10 col-md-10 col-lg-12">
                                            <h5 className={styles.fwbold}>Book a Risk-Free Home-Trial @ Rs. 299 Only</h5>
                                            <p className={styles.textmuted} style={{ fontSize: 13, textAlign: "justify" }}>Experience the care before you make a decision</p>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={"col-lg-3 col-md-12 col-sm-12 text-center p-3"}>
                                    {/* <FontAwesomeIcon icon="elevator" size="2x" /> */}
                                    <Row style={{ position: "relative" }}>
                                        <Col className="ps-3 col-2 col-sm-2 col-md-2 col-lg-12">
                                            <hr className={styles.dottedLine} />
                                            <img src={Evaluate} alt="React Logo" className={styles.image} />
                                        </Col>
                                        <Col className="col-10 col-sm-10 col-md-10 col-lg-12">
                                            <h5 className={styles.fwbold}>Evaluate the Caregiver</h5>
                                            <p className={styles.textmuted} style={{ fontSize: 13, textAlign: "justify" }}>Interview the caregiver and let them perform all required tasks for the patient at the comfort of your home within the 2 hours trial period</p>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={"col-lg-3 col-md-12 col-sm-12 text-center p-3"}>
                                    {/* <FontAwesomeIcon icon="book" size="2x" /> */}
                                    <Row style={{ position: "relative" }}>
                                        <Col className="ps-3 col-2 col-sm-2 col-md-2 col-lg-12">
                                            <hr className={styles.dottedLine} />
                                            <img src={FullService} alt="React Logo" className={styles.image} />
                                        </Col>
                                        <Col className="col-10 col-sm-10 col-md-10 col-lg-12">
                                            <h5 className={styles.fwbold}>Book the Full Service Online (Extra 10% off)</h5>
                                            <p className={styles.textmuted} style={{ fontSize: 13, textAlign: "justify" }}>Once you’re satisfied with the caregiver, book the full services online by visiting www.care24.co.in</p>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={"col-lg-3 col-md-12 col-sm-12 text-center p-3"}>
                                    {/* <FontAwesomeIcon icon="server" size="2x" /> */}
                                    <Row>
                                        <Col className="ps-3 col-2 col-sm-2 col-md-2 col-lg-12">
                                            <img src={UsingService} alt="React Logo" className={styles.image} style={{ paddingBottom: 10 }} />
                                        </Col>
                                        <Col className="col-10 col-sm-10 col-md-10 col-lg-12">
                                            <h5 className={styles.fwbold}>Start using the Service</h5>
                                            <p className={styles.textmuted} style={{ fontSize: 13, textAlign: "justify" }}>After booking, your dedicated Care Manager will call you to start the Caregiver service at your home as per your directions</p>
                                        </Col>
                                    </Row>
                                </div >
                            </Row >
                        </div >
                    </div>
                </Row>

            </div>
        </>
    );
}

export default TimeLineChart